// Statsig silently drops events whose names contain any of these characters:
// [, ], {, }, <, >, #, =, ;, &, $, %, |, NUL, \n, \r
// Source: https://docs.statsig.com/guides/logging-events#naming-conventions
//
// Mixpanel accepts those characters fine, so we sanitize only the Statsig
// event name and leave the Mixpanel name (and its existing dashboards)
// untouched. Call this at every Statsig.logEvent call site (client + server).
const STATSIG_FORBIDDEN_CHARS = /[\[\]{}<>#=;&$%|\0\n\r]/g;

export function sanitizeStatsigEventName(name: string): string {
  return name
    .replace(STATSIG_FORBIDDEN_CHARS, "")
    .replace(/[ \t]+/g, " ")
    .trim();
}
